import React, { ReactNode, useEffect, useRef, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { HelpCircleIcon } from 'lucide-react';

/** Kratka razlaga pravila na zahtevo – namesto dolgega besedila na zaslonu. */
export function HelpTip({
  label,
  children
}: {
  label: string;
  children: ReactNode;
}) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLSpanElement>(null);
  useEffect(() => {
    if (!open) return;
    const onDown = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && setOpen(false);
    document.addEventListener('mousedown', onDown);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDown);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);
  return <span ref={ref} className="relative inline-flex" data-id="element-1269" data-mp="145ex6s23hp5e">
      <button type="button" onClick={() => setOpen(o => !o)} aria-expanded={open} aria-label={label} className="grid h-8 w-8 place-items-center rounded-full text-muted transition-colors duration-150 hover:bg-canvas hover:text-ink focus-visible:outline focus-visible:outline-2 focus-visible:outline-accent" data-id="element-1270" data-mp="13e1eu09opun7">
        <HelpCircleIcon className="h-4 w-4" aria-hidden="true" data-id="element-1271" data-mp="og91nerm1ic6" />
      </button>
      <AnimatePresence data-id="element-1272" data-mp="kg8odxg8zd6p">
        {open && <motion.span role="note" initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} exit={{
        opacity: 0,
        scale: 0.96
      }} transition={{
        duration: 0.15,
        ease: [0.23, 1, 0.32, 1]
      }} className="absolute right-0 top-full z-30 mt-1 block w-72 origin-top-right rounded-2xl border border-line bg-surface p-3 text-left text-xs font-semibold leading-relaxed text-ink shadow-bar" data-id="element-1273" data-mp="kh0amhnyfykb">
            {children}
          </motion.span>}
      </AnimatePresence>
    </span>;
}